import { Document, Font, Page, Text, View } from '@react-pdf/renderer';
import global from 'global';
import ArabicFont from './Amiri-Bold.ttf';
import { pdfStyles } from './style';

Font.register({
	family: 'Roboto',
	fonts: [
		{
			src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
			fontWeight: 'medium',
		},
		{
			src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
			fontWeight: 'bold',
		},
	],
});

Font.register({
	family: 'Amiri',
	fonts: [
		{
			src: ArabicFont,
			fontWeight: 'light',
		},
	],
});

const fieldCheck = (check: boolean | '-') => {
	if (check === true) return 'Pass';
	if (check === false) return 'Review';
	if (check === null) return 'Reject';
	if (check === '-') return '-';
};

export const OCRPdf = ({
	application,
	groupLoan,
}: {
	application: global.application | null;
	groupLoan?: boolean;
}) => {
	return (
		<Document>
			{application?.ocr_log && (
				<Page style={pdfStyles.page}>
					<View style={pdfStyles.heading}>
						<Text>OCR report {!groupLoan && `(Client)`}</Text>
						<Text style={pdfStyles.heading2}>
							Decision:{' '}
							<Text
								style={
									application.ocr_log.is_approved === 'approved'
										? pdfStyles.approved
										: application.ocr_log.is_approved === 'review'
											? pdfStyles.review
											: pdfStyles.rejected
								}
							>
								{application.ocr_log.is_approved}
							</Text>
						</Text>
					</View>
					<View style={pdfStyles.section}>
						<Text style={pdfStyles.text}>Application ID: {application.id}</Text>
						<View style={pdfStyles.table}>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.th}>
									<Text>CRIF parameter</Text>
								</View>
								<View style={pdfStyles.th}>
									<Text>Value</Text>
								</View>
								<View style={pdfStyles.th}>
									<Text>Check</Text>
								</View>
							</View>

							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>Loans with payment overdue more than 29 days</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.loans_with_overdue_above_29_days?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>
										{fieldCheck(application.ocr_log.loans_with_overdue_above_29_days?.check)}
									</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>Stop words</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>
										{application.ocr_log.is_stop_words?.value === true
											? 'Yes'
											: application.ocr_log.is_stop_words?.value === false
												? 'No'
												: application.ocr_log.is_stop_words?.value}
									</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.is_stop_words?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>National ID</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.national_id?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.national_id?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>Birthday</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.birthday?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.birthday?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>Mobile number</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.mobile_number?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.mobile_number?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>[Non-AMC] Number of loans activated in the last 3 months</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.received_loans_2_months?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.received_loans_2_months?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>[Non-AMC] Number of active loans and credit cards</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.active_loans_credit_cards?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.active_loans_credit_cards?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>[Non-AMC] Total monthly payment in active loans</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.total_payments_amount?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.total_payments_amount?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>[Non-AMC] Active one-month loans</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.one_month_loans?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.one_month_loans?.check)}</Text>
								</View>
							</View>
							<View style={pdfStyles.tr}>
								<View style={pdfStyles.td}>
									<Text>[Non-AMC] Number of loans requested in the last 2 months</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{application.ocr_log.requested_loans_2_months?.value}</Text>
								</View>
								<View style={pdfStyles.td}>
									<Text>{fieldCheck(application.ocr_log.requested_loans_2_months?.check)}</Text>
								</View>
							</View>
						</View>
					</View>
				</Page>
			)}

			{application?.ocr_log?.gurantor_records &&
				!groupLoan &&
				(!Array.isArray(application?.ocr_log?.gurantor_records)
					? [application?.ocr_log?.gurantor_records]
					: application?.ocr_log?.gurantor_records
				).map((gr, index) => (
					<Page style={pdfStyles.page} key={index}>
						<View style={pdfStyles.heading}>
							<Text>OCR report (Guarantor {index + 1}) </Text>
							<Text style={pdfStyles.heading2}>
								Decision:{' '}
								<Text
									style={
										gr.is_approved === 'approved'
											? pdfStyles.approved
											: gr.is_approved === 'review'
												? pdfStyles.review
												: pdfStyles.rejected
									}
								>
									{gr.is_approved}
								</Text>
							</Text>
						</View>
						<View style={pdfStyles.section}>
							<View style={pdfStyles.table}>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.th}>
										<Text>CRIF parameter</Text>
									</View>
									<View style={pdfStyles.th}>
										<Text>Value</Text>
									</View>
									<View style={pdfStyles.th}>
										<Text>Check</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>Loans with payment overdue more than 29 days</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.loans_with_overdue_above_29_days?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.loans_with_overdue_above_29_days?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>Stop words</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>
											{gr.is_stop_words?.value === true
												? 'Yes'
												: gr.is_stop_words?.value === false
													? 'No'
													: gr.is_stop_words?.value}
										</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.is_stop_words?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>National ID</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.national_id?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.national_id?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>Birthday</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.birthday?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.birthday?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>Mobile number</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.mobile_number?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.mobile_number?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>[Non-AMC] Number of loans activated in the last 3 months</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.received_loans_2_months?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.received_loans_2_months?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>[Non-AMC] Number of active loans and credit cards</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.active_loans_credit_cards?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.active_loans_credit_cards?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>[Non-AMC] Total monthly payment in active loans</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.total_payments_amount?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.total_payments_amount?.check)}</Text>
									</View>
								</View>
								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>[Non-AMC] Active one-month loans</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.one_month_loans?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.one_month_loans?.check)}</Text>
									</View>
								</View>

								<View style={pdfStyles.tr}>
									<View style={pdfStyles.td}>
										<Text>[Non-AMC] Number of loans requested in the last 2 months</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{gr.requested_loans_2_months?.value}</Text>
									</View>
									<View style={pdfStyles.td}>
										<Text>{fieldCheck(gr.requested_loans_2_months?.check)}</Text>
									</View>
								</View>
							</View>
						</View>
					</Page>
				))}
		</Document>
	);
};
